import {
  readCookie,
} from '../tools/Cookie';

const IMtest = 'im-bypass';

window.imEnabled = null;

function init() {
  const cookieValue = readCookie(IMtest);

  if (cookieValue) {
    window.imEnabled = cookieValue;
  }
}

export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/widgets/ImageManager.js